import React from 'react'
import './HeroImg2.css'
import Project from '../../resources/assets/project.jpg'

const HeroImg2 = (props) => {
  return (
    <div className='hero-img' >
        <div className='heading-hero-img2' >
            <h1>{props.heading}</h1>
            <p>{props.text}</p>
        </div>
    </div>
  )
}

export default HeroImg2